
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host([toplevel]){
  height:100%;
  width:100%;
}

:host([bold]) .menu-link{
    font-size:var(--fs-xl);
    line-height:var(--lh-xl);
    font-weight:700;
  }

:host([bold]) .menu-link a{
      color:var(--color-neutral-dark);
    }

:host([active]) .menu-link > a{
    border-bottom:2px solid var(--color-gray-400);
  }

:host([active]) .menu-link.mobile > a{
    border-bottom:none;
  }

.menu-link,
.menu-link--main{
  display:flex;
  width:100%;
  text-decoration:none;
  transition:0;
}

.menu-link a, .menu-link--main a{
    text-decoration:none;
  }

.menu-link li, .menu-link--main li{
    list-style:none;
  }

.menu-link--main{
  display:flex;
  position:relative;
  width:100%;
  justify-content:flex-start;
  height:100%;
  align-items:center;
  padding:0 0.5rem;
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  color:var(--color-neutral-dark);
  transition:0s;
}

@media (min-width: 1024px){

.menu-link--main{
    justify-content:center
}
  }

.menu-link--main a{
    color:var(--color-neutral-dark);
  }

.menu-link{
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  font-weight:400;
}

.menu-link a{
    color:var(--color-gray-400);
  }

.menu-link:hover{
    text-decoration:underline;
  }

.menu-link.mobile,
.menu-link--main.mobile{
  width:100%;
  height:100%;
  transition:0.5s;
}

.menu-link.mobile a, .menu-link--main.mobile a{
    padding:1rem;
    width:100%;
  }

.menu-link.mobile a:focus, .menu-link--main.mobile a:focus{
    outline:solid 2px var(--color-primary-default);
    outline-offset:-1px;
  }

.flyaway{
  transform:translateX(-150%);
  visibility:hidden;
  opacity:0;
  padding:0 !important;
  margin:0 !important;
  height:0 !important;
  border:none !important;
}
`;